import { Box, Card, Grid, Stack } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import PaginationComponent from '../../components/widgets/paginationComponent';
import CaseStudyBulletOnlyRegion from './caseStudyBulletOnlyRegion';
import { useTranslation } from "react-i18next";
import TitleComponent from "../../components/widgets/titleComponent";
import projectData from '../../assets/data/projects.json';

const CaseStudyProject = ({
    industryKeyword
}) => {
    const {t} = useTranslation();

    const [activePage, setActivePage] = useState(0);
    const [projectsList, setProjectsList] = useState([]);

    useEffect(() => {
        const list = [];

        for(let i = 0; i < projectData.ai.length; i++){
            if(projectData.ai[i].category === industryKeyword){
                list.push(projectData.ai[i]);
            }
        }

        for(let i = 0; i < projectData.games.length; i++){
            if(projectData.games[i].category === industryKeyword){
                list.push(projectData.games[i]);
            }
        }

        for(let i = 0; i < projectData.mobile.length; i++){
            if(projectData.mobile[i].category === industryKeyword){
                list.push(projectData.mobile[i]);
            }
        }

        for(let i = 0; i < projectData.web.length; i++){
            if(projectData.web[i].category === industryKeyword){
                list.push(projectData.web[i]);
            }
        }

        setProjectsList(list);
    }, [industryKeyword]);
    
    const changePage = useCallback((page) => {
        setActivePage(page);
    }, []);

    return (
        <>
            <TitleComponent title={t('caseStudies.projects')} centerMode/>

            <Stack
                direction='column'
                justifyContent='center'
                alignItems='center'
                width='100%'
            >
                <Card
                    elevation={0}
                    sx={{
                        borderRadius: 6,
                        width: '100%'
                    }}
                >
                    <Grid
                        direction='row'
                        justifyContent='center'
                        alignItems='center'
                        container
                    >
                        <Grid 
                            size={{xs: 12, md: 6}}
                            position='relative'
                            sx={{ 
                                aspectRatio: '1/1', 
                                display: 'flex', 
                                justifyContent: 'center', 
                                alignItems: 'center' 
                            }}
                        >
                            <Box 
                                sx={{
                                    backgroundImage: `url(${projectsList[activePage]?.banner})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'cover',
                                    backgroundPosition: "center",
                                    width: '100%',
                                    height: '100%',
                                    filter: 'blur(10px)',
                                    opacity: 0.75,
                                    position: 'absolute'
                                }}
                            />

                            <img 
                                src={projectsList[activePage]?.banner} 
                                alt="Banner"
                                width='75%'
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    zIndex: 1,
                                    borderRadius: 16
                                }}
                            />
                        </Grid>

                        <Grid 
                            size={{xs: 12, md: 6}}
                            sx={{
                                p: {xs: 2, md: 5}
                            }}
                        >
                            <CaseStudyBulletOnlyRegion 
                                title={projectsList[activePage]?.name}
                                data={projectsList.length > 0 ? projectsList[activePage]?.features : []}
                            />
                        </Grid>
                    </Grid>
                </Card>

                {/* Pagination */}
                <PaginationComponent 
                    totalItems={projectsList.length}
                    itemsPerPage={1}
                    activePage={activePage}
                    onPageChange={changePage}
                />
            </Stack>
        </>
    );
}

export default CaseStudyProject;